import { motion } from 'framer-motion'

function GoogleMap() {
  return (
    <section className="py-16 bg-white">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-pacieh-blue mb-4">
            Visit Goodwill Medical Centre
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Located in Umuchigbo, serving Ifo, Ugbo-Ezeji, and Ugbo-Paul communities
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="relative w-full h-[500px] rounded-2xl overflow-hidden shadow-xl"
        >
          <iframe
            src="https://maps.google.com/maps?q=Goodwill+Medical+Centre+Umuchigbo+Enugu+Nigeria&t=&z=14&ie=UTF8&iwloc=&output=embed"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Goodwill Medical Centre Location"
          />
        </motion.div>
      </div>
    </section>
  )
}

export default GoogleMap 